<template>
  <!-- 语速选择 -->
  <SelectPopper v-bind="$attrs" v-on="$listeners" :value="value" :options="speedArr" />
</template>
<script>
import SelectPopper from "../select-popper/select-popper.vue"
export default {
  components: {
    SelectPopper
  },
  props: {
    value: {
      type: String,
      default: '1.0'
    }
  },
  created() {
    this.speedArr = [
      "0.1",
      "0.15",
      "0.2",
      "0.25",
      "0.3",
      "0.35",
      "0.4",
      "0.45",
      "0.5",
      "0.55",
      "0.6",
      "0.65",
      "0.7",
      "0.75",
      "0.8",
      "0.85",
      "0.9",
      "0.95",
      "1.0",
      "1.05",
      "1.1",
      "1.15",
      "1.2",
      "1.25",
      "1.3",
      "1.35",
      "1.4",
      "1.45",
      "1.5",
      "1.55",
      "1.6",
      "1.65",
      "1.7",
      "1.75",
      "1.8",
      "1.85",
      "1.9",
      "1.95",
      "2.0",
    ]
  },
  methods: {

  }
}
</script>